module.exports = __webpack_public_path__ + "img/permission_error.b196d0b8.svg";